import configureStoreDev from "./configureStore.dev";
import configureStoreProd from "./configureStore.prod";
import configureStoreStaging from "./configureStore.staging";

let configureStore;

if (window._env_?.REDUX_DEVTOOLS) {
  configureStore = configureStoreDev;
} else if (["production"].includes(window._env_?.NODE_ENV)) {
  configureStore = configureStoreProd;
} else if (["staging"].includes(window._env_?.NODE_ENV)) {
  configureStore = configureStoreStaging;
} else {
  configureStore = configureStoreDev;
}

export default configureStore;
